<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("产品") }}</span>
                </div>
                <div class="md-layout-item item-no_of_result">{{this.products.length}}{{ $t("件产品") }}</div>
              </div>
            </md-card-content>
          </md-card>

          <div class="md-layout">
            <div class="md-layout-item md-size-25 md-xsmall-size-100">
              <md-card class="md-card-category">
                <div class="container">
                  <div class="md-title title-category">{{ $t("分类") }}</div>
                  <md-divider></md-divider>
                </div>

                <md-card-content>
                  <div class="div-category" @click="selectCategory(false)" :class="{ selected_category : (!search_criteria.category_selected)}">{{ $t("所有产品") }}</div>
                  <div :key="category_i" v-for="(category, category_i) in categorys" class="div-category" @click="selectCategory(category)">
                    <div :class="{ selected_category : (search_criteria.category_selected == category.id)}">{{category.name_cn}}</div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
            <div class="md-layout-item md-xsmall-size-100">
              <div>
                <div class="md-layout">
                  <div
                    v-for="(product, product_i) in products"
                    :key="product_i"
                    class="md-layout-item md-size-33 md-xsmall-size-100"
                  >
                    <md-card md-with-hover>
                      <router-link :to="{ name: 'product', params: {id: product.id}}">
                        <md-card-media>
                          <img :src="product.image_url" />
                        </md-card-media>
                      </router-link>

                      <div class="container">
                        <div class="md-title">{{product.name_cn}}</div>
                        <div class="md-subhead">${{product.price}}</div>
                      </div>

                      <md-card-actions>
                          <md-button class="md-primary" @click="addToCart(product.id)">{{ $t("加到购物车") }}</md-button>
                      </md-card-actions>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <md-dialog-confirm
      :md-active.sync="show_confirm"
      md-title="提示"
      md-content="成功加到購物車"
      md-confirm-text="前住購物車"
      md-cancel-text="繼續瀏覽"
      @md-cancel="onCancelConfirm"
      @md-confirm="onConfirmConfirm" />
  </div>
</template>

<script>
export default {
  components: {},
  name: "products",
  bodyClass: "products-page",
  props: {},
  data() {
    return {
      search_criteria: {},
      products: [],
      categorys : [],
      show_confirm : false,
    };
  },
  methods: {

    selectCategory(category){
      if(category){
        this.search_criteria.category_selected = category.id;
      }else{
        this.search_criteria = {};
      }

      this.getProducts();
    },

    async getProducts() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_product_get.php",
        data: {
          search_criteria: this.search_criteria
        }
      });
      this.products = response.data.products;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    async getCategorys() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_category_get.php",
        data: {
        }
      });
      this.categorys = response.data.categorys;
      this.loader.hide();
    },

    async addToCart(product_id) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_cart_add.php",
        data: {
          member_id: this.$store.state.member_id,
          product_id: product_id,
          quantity: 1
        }
      });

      this.show_confirm = true;
      // this.$router.push({ name: "cart", params: {} });
    },

    onCancelConfirm(){
      this.show_confirm = false;
    },
    onConfirmConfirm(){
      this.$router.push({ name: "cart", params: {} });
    },
  },
  computed: {},
  async created() {
    await this.getProducts();
    await this.getCategorys();
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.item-no_of_result {
  text-align: right;
}

.title-category {
  padding-top: 10px;
  padding-bottom: 10px;
}

.md-card.md-card-category {
  box-shadow: none;
}

.md-card .md-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected_category{
  font-weight: bold;
  color: #4caf50;
}
</style>